function initSlinky() {
	try {
		var slinky = $('.js-menusss').slinky({
			title: true,
		})
	} catch {}
}
